export const common = {
  ourServices: "Servicii",
  services: "Servicii",
  details: "detalii",
  accountsInUk: "Contabili în Marea Britanie",
  accountsInUkText:
    "Oferim clienților noștri expertiza, resursele și suportul de care au nevoie pentru a gestiona cu încredere toate aspectele contabilității lor. Echipa noastră se asigură că fiecare detaliu este gestionat cu acuratețe și la timp, oferind un serviciu personalizat și rezultate de încredere. Datorită angajamentului nostru de a face calculele corect încă de la început, vă puteți concentra pe afacerea dumneavoastră în timp ce noi ne ocupăm de restul.",
  weSpeak: "Noi vorbim limba ta",
  whoWeHelp: "Afaceri pe care le susținem",
  viewDetails: "Vezi detalii",
  whyChooseUs: "Avantajele de a lucra cu noi",
  contactUs: "Contacte",
  soleTrader: "Persoană Fizică Autorizată ",
  limitedCompanies: "Societăți cu Răspundere Limitată (SRL)",
  partnership: "Parteneriat",
  quickLinks: "Linkuri",
  aboutUs: "Despre Noi",
  blog: "Blog",
  seeMore: "Vezi mai mult",
  backToBlog: "Înapoi la blog",
  noPosts: "Nu există articole încă.",
  postNotFound: "Articolul nu a fost găsit.",
  blogLoadError: "Nu am putut încărca articolele. Încercați mai târziu.",
  prevPage: "Pagina anterioară",
  nextPage: "Pagina următoare",
  pagination: "Pagini",
  contactFormName: "Nume *",
  contactFormPhone: "Telefon *",
  contactFormEmail: "Email (opțional)",
  contactFormMessage: "Mesaj *",
  contactFormSend: "Trimite mesajul",
  contactFormSending: "Se trimite...",
  contactFormSent: "Mesajul a fost trimis. Vă vom contacta în curând.",
  contactFormAnother: "Trimite alt mesaj",
  contactFormError: "Mesajul nu a putut fi trimis. Încercați mai târziu sau contactați-ne direct.",
};
